import { CampaignDetailsState } from "./campaignDetails.types";

export const initialState: CampaignDetailsState = {
  data: {
      temp_id: "",
      id: "",
      short_id: "",
      user_id: 0,
      goal: 0,
      total_raised: 0,
      name: "Loading...",
      description: "",
      default_image: "https://placehold.co/200x200?text=No+Image",
      location: "",
      shortened_location: "",
      awards: null,
      status: "active",
      created_at: "",
      updated_at: "",
      start_date_time: "",
      end_date_time: "",
      project_id: 0,
      count_donor: 0,
      user: {
        id: 0,
        name: "Loading...",
        socialAvatarUrl: "https://placehold.co/200x200?text=No+Logo",
      }
  },
  loading: false,
  error: null,
  shortIdValidation: { valid: null, message: null },
  updateSuccess: false,
};

export interface CampaignCreateState {
  loading: boolean;
  successId: string | null;
  error: string | null;
}

export const initialCreateState: CampaignCreateState = {
  loading: false,
  successId: null,
  error: null,
};
